module.exports = __webpack_public_path__ + "static/turtle-creek-house38-929ee124ff320cd46ae1bf5f4f4997d2.jpg";